<script lang="ts">
  // libs
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  // components
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";

  // services
  import {
    getContainerCountString,
    getOrderContainerCounts,
  } from "@retailer/services/order_quantities_service";

  // stores
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  // types
  import type { CartType } from "@shared/types/Cart";

  // props
  export let cart: CartType;

  // functions
  const getDeliveryMethodBreakdown = (order, method) => {
    if (method === "delivery") {
      return (
        "Delivery: " +
        getContainerCountString(
          getOrderContainerCounts(
            order.products.filter((product, i) => !product.warehouse_id && !product.requested_item),
          ),
        )
      );
    } else if (method === "pickup") {
      return (
        "In store pickup: " +
        getContainerCountString(
          getOrderContainerCounts(
            order.products.filter(
              (product, i) => !!product.warehouse_id && !product.requested_item,
            ),
          ),
        )
      );
    } else {
      return null;
    }
  };

  const showDeliveryBreakdown = order =>
    order.products.filter(
      (product, i) => !product.warehouse_id && product.unit_diff !== -1 * product.unit_quantity,
    ).length > 0;
  const showPickupBreakdown = order =>
    order.products.filter(
      (product, i) => !!product.warehouse_id && product.unit_diff !== -1 * product.unit_quantity,
    ).length > 0;

  $: submittableOrders = cart.orders.filter(order => !order.distributor?.ordering_disabled);
</script>

{#each submittableOrders as order}
  {#if order.products.find(product => !product.deleted)}
    <div class:fizz-stack-8={$LayoutStore.isMobile}>
      <div class="fizz-flex-row fizz-space-between fizz-stack-2">
        <p class="fizz-text-strong">{order.distributor.name}</p>

        {#if (order.total == 0 || !order.total) && !order.products.every(product => product.requested_item)}
          <div class="fizz-tooltip-container">
            <button
              class="fizz-tooltip-trigger fizz-flex-row-8"
              aria-describedby={`tooltip-order-total-${order.id}`}
            >
              <span class="fizz-underline-dashed fizz-text-subdued" style="font-weight: 400;">
                Price not available
              </span>
            </button>
            <div
              id={`tooltip-order-total-${order.id}`}
              data-testid={`tooltip-order-total-${order.id}`}
              class="fizz-tooltip fizz-tooltip-right"
              class:fizz-tooltip-top={$LayoutStore.isDesktop}
              role="tooltip"
              style="--max-width: 260px;"
            >
              This distributor does not provide us with pricing information.
            </div>
          </div>
        {:else}
          <span class="fizz-text-strong"><FormatMoney input={order.total} formatType="5" /></span>
        {/if}
      </div>
      {#if order.distributor.uses_warehouse_pickup}
        {#if showDeliveryBreakdown(order)}
          <p class="fizz-text-small">
            {getDeliveryMethodBreakdown(order, "delivery")}
          </p>
        {/if}
        {#if showPickupBreakdown(order)}
          <p class="fizz-text-small">
            {getDeliveryMethodBreakdown(order, "pickup")}
          </p>
        {/if}
      {:else}
        <p class="fizz-text-small">
          {getContainerCountString(getOrderContainerCounts(order?.products))}
        </p>
      {/if}
    </div>

    {#if order.products.find(product => product.requested_item)}
      <p class="fizz-text-subdued fizz-text-small">
        Subject to change if requested items are fulfilled.
      </p>
    {/if}
  {/if}
{/each}
